import { Controller } from "@hotwired/stimulus"

// Opens the browser's print dialog ("Save as PDF" on desktop, iOS and Android).
export default class extends Controller {
  print(event) {
    event.preventDefault()
    window.print()
  }
}
